[
  {
    "id": "well",
    "w": 2.6,
    "d": 2.6,
    "h": 3.6,
    "collider": "circle"
  },
  {
    "id": "house_small",
    "w": 6,
    "d": 5,
    "h": 6.3,
    "collider": "box"
  },
  {
    "id": "house_large",
    "w": 9,
    "d": 6,
    "h": 8.9,
    "collider": "box"
  },
  {
    "id": "tavern",
    "w": 12,
    "d": 8,
    "h": 9.2,
    "collider": "box"
  },
  {
    "id": "smithy",
    "w": 8,
    "d": 7,
    "h": 6.5,
    "collider": "box"
  },
  {
    "id": "chapel",
    "w": 7,
    "d": 11,
    "h": 9.5,
    "collider": "box"
  },
  {
    "id": "tower",
    "w": 4,
    "d": 4,
    "h": 10.5,
    "collider": "box"
  },
  {
    "id": "market_stall",
    "w": 3.5,
    "d": 2.4,
    "h": 2.8,
    "collider": "box"
  },
  {
    "id": "lamp",
    "w": 0.3,
    "d": 0.3,
    "h": 3.1,
    "collider": "circle"
  },
  {
    "id": "banner",
    "w": 0.3,
    "d": 0.3,
    "h": 4.7,
    "collider": "circle"
  },
  {
    "id": "crate",
    "w": 1,
    "d": 1,
    "h": 1.1,
    "collider": "box"
  },
  {
    "id": "barrel",
    "w": 0.8,
    "d": 0.8,
    "h": 1,
    "collider": "circle"
  },
  {
    "id": "cart",
    "w": 1.8,
    "d": 3.2,
    "h": 1.7,
    "collider": "box"
  },
  {
    "id": "haystack",
    "w": 2.2,
    "d": 2.2,
    "h": 2.7,
    "collider": "circle"
  },
  {
    "id": "tree_oak",
    "w": 0.9,
    "d": 0.9,
    "h": 5,
    "collider": "circle"
  },
  {
    "id": "tree_pine",
    "w": 0.8,
    "d": 0.8,
    "h": 6,
    "collider": "circle"
  },
  {
    "id": "rock",
    "w": 2,
    "d": 2,
    "h": 1,
    "collider": "circle"
  },
  {
    "id": "bush",
    "w": 1.4,
    "d": 1.4,
    "h": 0.9,
    "collider": "none"
  },
  {
    "id": "tree_birch",
    "w": 0.7,
    "d": 0.7,
    "h": 5.5,
    "collider": "circle"
  },
  {
    "id": "tree_dead",
    "w": 0.7,
    "d": 0.7,
    "h": 4.5,
    "collider": "circle"
  },
  {
    "id": "stump",
    "w": 0.9,
    "d": 0.9,
    "h": 0.6,
    "collider": "circle"
  },
  {
    "id": "log",
    "w": 0.8,
    "d": 3.2,
    "h": 0.7,
    "collider": "box"
  },
  {
    "id": "boulder",
    "w": 2.6,
    "d": 2.6,
    "h": 2,
    "collider": "circle"
  },
  {
    "id": "cliff",
    "w": 6,
    "d": 5,
    "h": 6,
    "collider": "box"
  },
  {
    "id": "mushroom",
    "w": 0.5,
    "d": 0.5,
    "h": 0.4,
    "collider": "none"
  },
  {
    "id": "fern",
    "w": 1,
    "d": 1,
    "h": 0.6,
    "collider": "none"
  },
  {
    "id": "grass",
    "w": 0.8,
    "d": 0.8,
    "h": 0.5,
    "collider": "none"
  },
  {
    "id": "flowers",
    "w": 0.9,
    "d": 0.9,
    "h": 0.4,
    "collider": "none"
  },
  {
    "id": "reeds",
    "w": 1,
    "d": 1,
    "h": 1.6,
    "collider": "none"
  },
  {
    "id": "tombstone",
    "w": 0.8,
    "d": 0.35,
    "h": 1.1,
    "collider": "box"
  },
  {
    "id": "crypt",
    "w": 6,
    "d": 8,
    "h": 5.5,
    "collider": "box"
  },
  {
    "id": "windmill",
    "w": 6,
    "d": 6,
    "h": 13,
    "collider": "box"
  },
  {
    "id": "barn",
    "w": 10,
    "d": 8,
    "h": 7.5,
    "collider": "box"
  },
  {
    "id": "fence",
    "w": 4,
    "d": 0.25,
    "h": 1.1,
    "collider": "box"
  },
  {
    "id": "field",
    "w": 12,
    "d": 8,
    "h": 0.5,
    "collider": "none"
  },
  {
    "id": "tent",
    "w": 3,
    "d": 3.6,
    "h": 2.4,
    "collider": "box"
  },
  {
    "id": "campfire",
    "w": 1.2,
    "d": 1.2,
    "h": 0.5,
    "collider": "circle"
  },
  {
    "id": "ruin_wall",
    "w": 6,
    "d": 1,
    "h": 3.5,
    "collider": "box"
  },
  {
    "id": "ruin_pillar",
    "w": 1.2,
    "d": 1.2,
    "h": 4,
    "collider": "circle"
  },
  {
    "id": "ruin_arch",
    "w": 5,
    "d": 1.2,
    "h": 5,
    "collider": "none"
  },
  {
    "id": "standing_stone",
    "w": 1.4,
    "d": 0.8,
    "h": 3.6,
    "collider": "box"
  },
  {
    "id": "bridge",
    "w": 5,
    "d": 22,
    "h": 1.2,
    "collider": "none"
  },
  {
    "id": "signpost",
    "w": 0.3,
    "d": 0.3,
    "h": 2.2,
    "collider": "circle"
  },
  {
    "id": "house_tall",
    "w": 6,
    "d": 5.5,
    "h": 9.5,
    "collider": "box"
  },
  {
    "id": "fountain",
    "w": 7.6,
    "d": 7.6,
    "h": 6,
    "collider": "circle"
  },
  {
    "id": "bench",
    "w": 2,
    "d": 0.6,
    "h": 1,
    "collider": "box"
  },
  {
    "id": "planter",
    "w": 1.8,
    "d": 1.8,
    "h": 1,
    "collider": "box"
  },
  {
    "id": "notice_board",
    "w": 2.2,
    "d": 0.4,
    "h": 2.6,
    "collider": "box"
  },
  {
    "id": "statue",
    "w": 2,
    "d": 2,
    "h": 4.5,
    "collider": "box"
  },
  {
    "id": "garden",
    "w": 5.8,
    "d": 3.8,
    "h": 0.6,
    "collider": "none"
  },
  {
    "id": "woodpile",
    "w": 1.6,
    "d": 1.6,
    "h": 1,
    "collider": "box"
  },
  {
    "id": "training_dummy",
    "w": 0.6,
    "d": 0.6,
    "h": 2.2,
    "collider": "circle"
  },
  {
    "id": "archery_target",
    "w": 1.4,
    "d": 0.8,
    "h": 2,
    "collider": "box"
  },
  {
    "id": "gatehouse",
    "w": 15,
    "d": 4,
    "h": 10,
    "collider": "none"
  },
  {
    "id": "sign_potion",
    "w": 0.3,
    "d": 0.3,
    "h": 3.2,
    "collider": "circle"
  },
  {
    "id": "sign_trade",
    "w": 0.3,
    "d": 0.3,
    "h": 3.2,
    "collider": "circle"
  },
  {
    "id": "sign_scroll",
    "w": 0.3,
    "d": 0.3,
    "h": 3.2,
    "collider": "circle"
  },
  {
    "id": "sign_anvil",
    "w": 0.3,
    "d": 0.3,
    "h": 3.2,
    "collider": "circle"
  },
  {
    "id": "orc_hut",
    "w": 6,
    "d": 6,
    "h": 6.5,
    "collider": "circle"
  },
  {
    "id": "longhouse",
    "w": 14,
    "d": 8,
    "h": 7,
    "collider": "box"
  },
  {
    "id": "totem",
    "w": 0.8,
    "d": 0.8,
    "h": 4.2,
    "collider": "circle"
  },
  {
    "id": "bonfire",
    "w": 3,
    "d": 3,
    "h": 1.6,
    "collider": "circle"
  },
  {
    "id": "gate_portal",
    "w": 6,
    "d": 1.2,
    "h": 7,
    "collider": "none"
  },
  {
    "id": "keep",
    "w": 20,
    "d": 18,
    "h": 20,
    "collider": "box"
  },
  {
    "id": "cathedral",
    "w": 11,
    "d": 20,
    "h": 18,
    "collider": "box"
  },
  {
    "id": "barracks",
    "w": 14.4,
    "d": 7.4,
    "h": 7.6,
    "collider": "box"
  },
  {
    "id": "hedge",
    "w": 4,
    "d": 1,
    "h": 1.5,
    "collider": "box"
  },
  {
    "id": "bone_pile",
    "w": 0.8,
    "d": 0.8,
    "h": 0.3,
    "collider": "none"
  },
  {
    "id": "skull_pole",
    "w": 0.4,
    "d": 0.4,
    "h": 3.2,
    "collider": "circle"
  },
  {
    "id": "spikes",
    "w": 4,
    "d": 1.2,
    "h": 1.4,
    "collider": "box"
  },
  {
    "id": "brazier",
    "w": 0.9,
    "d": 0.9,
    "h": 1.8,
    "collider": "circle"
  },
  {
    "id": "war_banner_human",
    "w": 0.4,
    "d": 0.4,
    "h": 7,
    "collider": "circle"
  },
  {
    "id": "war_banner_orc",
    "w": 0.4,
    "d": 0.4,
    "h": 7,
    "collider": "circle"
  },
  {
    "id": "victory_banner",
    "w": 2.4,
    "d": 2.4,
    "h": 10,
    "collider": "circle"
  },
  {
    "id": "tree_snowpine",
    "w": 0.8,
    "d": 0.8,
    "h": 6,
    "collider": "circle"
  },
  {
    "id": "ice_spike",
    "w": 1.2,
    "d": 1.2,
    "h": 3.2,
    "collider": "circle"
  },
  {
    "id": "ice_rock",
    "w": 2,
    "d": 2,
    "h": 1,
    "collider": "circle"
  },
  {
    "id": "snowdrift",
    "w": 2.4,
    "d": 2.4,
    "h": 0.5,
    "collider": "none"
  },
  {
    "id": "basalt",
    "w": 2,
    "d": 2,
    "h": 1.2,
    "collider": "circle"
  },
  {
    "id": "obsidian_spike",
    "w": 1.2,
    "d": 1.2,
    "h": 3.4,
    "collider": "circle"
  },
  {
    "id": "lava_pool",
    "w": 3.2,
    "d": 3.2,
    "h": 0.1,
    "collider": "none"
  },
  {
    "id": "ember_vent",
    "w": 1.2,
    "d": 1.2,
    "h": 0.4,
    "collider": "none"
  }
]
